/*
 * Collection inifinite scroll and restore scroll position
 */

let currentPage = 1;
let container = document.querySelector('.products-grid');
let intersectionObserver;
const trigger = document.querySelector('.collection-load-more');
let totalPages = parseInt(trigger?.dataset.pages, 10);

// Fetch products with pagination
async function getProducts() {
  // Return if no more pages and increment current page
  if (currentPage === totalPages) {
    trigger.remove();
    return;
  }
  currentPage += 1;

  // Fetch next page products
  const fetchUrl = window.location.href.includes('?')
    ? `${window.location.href}&page=${currentPage}`
    : `${window.location.href}?page=${currentPage}`;
  const response = await fetch(fetchUrl);
  const text = await response.text();

  // Convert to HTML
  const parser = new DOMParser();
  const html = parser.parseFromString(text, 'text/html');

  // Append next page products to container
  const grid = html?.querySelector('.products-grid').children;
  // Filter out <template> elements from the grid - parameter push-up functionality
  const filteredGrid = [...grid].filter((node) => node.tagName !== 'TEMPLATE');

  container.append(...filteredGrid);
  intersectionObserver.observe(trigger);
  // Dispatch event for grid swatch images
  document.dispatchEvent(new CustomEvent('collection:paginated'));
}

// Intersection observer for load more trigger
intersectionObserver = new IntersectionObserver(
  (entries) => {
    const isIntersecting = entries[0]?.isIntersecting ?? false;
    if (isIntersecting) {
      getProducts();
    }
  },
  {rootMargin: '-10% 0px 0px 0px'}
);

// Check if navigation by back button
const isBackNavigation = () => {
  const perfEntries = performance.getEntriesByType('navigation');
  for (let i = 0; i < perfEntries?.length; i += 1) {
    if (perfEntries[i]?.type === 'back_forward') {
      return true;
    }
  }
  return false;
};

// Restore scroll position on back navigation
const restoreScrollState = async () => {
  const scrollPosition = sessionStorage.getItem('scrollPosition');
  const pagesToLoad = parseInt(sessionStorage.getItem('currentPage'), 10);

  if (scrollPosition === null) return;
  window.history.scrollRestoration = 'manual';
  // Fetch products
  for (let i = 1; i < pagesToLoad; i += 1) {
    // eslint-disable-next-line no-await-in-loop
    await getProducts();
  }

  // Smooth scrolling
  setTimeout(() => window.scrollTo({top: scrollPosition, behavior: 'smooth'}), 1000);
  sessionStorage.removeItem('scrollPosition');
};

// Event listeners for back navigation (scroll position), collection reload, DOM content loaded
window.addEventListener('beforeunload', () => {
  sessionStorage.setItem('scrollPosition', window.scrollY);
  sessionStorage.setItem('currentPage', currentPage);
});

// ios fix
window.addEventListener('onpagehide', () => {
  sessionStorage.setItem('scrollPosition', window.scrollY);
  sessionStorage.setItem('currentPage', currentPage);
});

document.addEventListener('DOMContentLoaded', () => {
  // start observing
  if (trigger) {
    intersectionObserver.observe(trigger);

    if (isBackNavigation()) {
      restoreScrollState();
    }
  }
});

document.addEventListener('collection:reloaded', () => {
  currentPage = 1;
  container = document.querySelector('.products-grid');
  totalPages = parseInt(trigger.dataset.pages, 10);
  // start observing
  if (trigger) intersectionObserver.observe(trigger);
});
